import { makeVar } from '@apollo/client';

export const resetPasswordStepVar = makeVar<
  'resetPassword' | 'confirmResetPassword' | 'passwordChanged'
>('resetPassword');
